import { DatePicker, Form } from 'antd'
import dayjs from 'dayjs'
import { formatEndDate, formatEndDateLeft } from 'shared/utils/endDate'

interface IEndDateFieldProps {
  // кто уходит в архив: «баннер», «подборка»
  subject: string
}

export const EndDateField = ({ subject }: IEndDateFieldProps) => (
  <Form.Item
    label='Дата окончания (срок размещения)'
    name='end_date'
    rules={[{ required: true, message: 'Укажите дату окончания' }]}
    extra={`После этой даты ${subject} уйдёт в архив.`}
  >
    <DatePicker
      format='DD.MM.YYYY'
      style={{ width: 200 }}
      disabledDate={(date) => date.isBefore(dayjs(), 'day')}
    />
  </Form.Item>
)

// Колонка списка: дата и сколько осталось второй строкой
export const EndDateCell = ({ value }: { value?: string | null }) => {
  const left = formatEndDateLeft(value)
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span>{formatEndDate(value)}</span>
      {left && <span style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 12 }}>{left}</span>}
    </div>
  )
}
